import React, { useState } from "react";
import { BasicTextInput } from "../FormComponent/BasicTextInput";
import { useLocation } from "react-router-dom";

const Step1 = ({ formData1, setFormData1 }) => {
  const location = useLocation();
  const data = location.state;
  const handleChangeFormData1 = (e) => {
    const { name, value } = e.target;
    setFormData1({
      ...formData1,
      [name]: value,
    });
  };
  return (
    <section className="">
      <h1 className="lg:text-4xl md:text-3xl sm:text-xl">
        Complete Your Listing Title
      </h1>
      <p className="text-[14px] mt-4 mb-8">
        For greater visibility, be sure to mention the specific features of your
        watch.
      </p>

      <BasicTextInput
        label={"Complete"}
        isRequired={true}
        type={"text"}
        id={"listingTitle"}
        name={"listingTitle"}
        value={formData1?.listingTitle}
        onChange={handleChangeFormData1}
        placeholder={"e.g., full set, special edition"}
      />

      <div className="rounded-lg bg-primary mt-12 px-4 pt-2 pb-4 ">
        <p className="font-semibold text-[14px]">Preview</p>
        <div className="bg-white border rounded-lg flex items-center gap-4 p-2.5 mt-1  border-gray-400">
          <img
            src={data.imageUrl}
            alt=""
            height={64}
            width={64}
            className="rounded border"
          />

          <div className="text-[14px]">
            <p>{data.title}</p>
            <p>
              {formData1.listingTitle
                ? formData1.listingTitle
                : "Listing name will be appear here..."}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Step1;
